module.exports = __webpack_public_path__ + "img/2-1.fd694d76.jpg";